import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss']
})
export class IconButtonComponent {
  /** Nhãn hiển thị bên cạnh icon */
  @Input() label: string = '';
  /** Class bổ sung nếu cần tuỳ biến thêm */
  @Input() extraClass: string = '';
  /** Sự kiện khi click nút */
  @Output() btnClick = new EventEmitter<MouseEvent>();

  onClick(event: MouseEvent) {
    this.btnClick.emit(event);
  }
}
